import { EntityBatchNode, type EntityBatchNodeProps } from "./EntityBatchNode";

export function ApplicationRecordBatchNode(props: Omit<EntityBatchNodeProps, "fallbackLabel">) {
  return <EntityBatchNode {...props} fallbackLabel="Application Record Batch" />;
}
